var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhilipins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11737_3784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5H39V25H11V14.5Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 25H39V35.5H11V25Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1865 25L11 35.5V14.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5297 27.1023C18.6895 27.1023 19.6297 26.1621 19.6297 25.0023C19.6297 23.8425 18.6895 22.9023 17.5297 22.9023C16.3699 22.9023 15.4297 23.8425 15.4297 25.0023C15.4297 26.1621 16.3699 27.1023 17.5297 27.1023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0938 25.0053L13.3686 25.2802L17.5271 25.0053L13.3686 24.7305L13.0938 25.0053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 25.5285L13.7869 25.753L17.5307 25.0078L13.5625 25.5285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 24.4871L13.7869 24.2627L17.5307 25.0078L13.5625 24.4871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3916 21.8701L14.3916 22.2589L17.5264 25.005L14.7803 21.8701L14.3916 21.8701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3584 22.5674L14.3584 22.8848L17.5325 25.0051L14.3584 22.5674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0948 21.831L15.4122 21.831L17.5325 25.0051L15.0948 21.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5298 20.5703L17.255 20.8452L17.5298 25.0036L17.8047 20.8452L17.5298 20.5703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0105 21.0352L16.7861 21.2596L17.5312 25.0033L17.0105 21.0352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.052 21.0352L18.2764 21.2596L17.5312 25.0033L18.052 21.0352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6572 21.8681L20.2685 21.8681L17.5224 25.003L20.6572 22.2569L20.6572 21.8681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9599 21.8271L19.6425 21.8271L17.5222 25.0012L19.9599 21.8271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6963 22.5635L20.6963 22.8809L17.5222 25.0012L20.6963 22.5635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9609 24.9986L21.6861 24.7237L17.5276 24.9986L21.6861 25.2734L21.9609 24.9986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4922 24.4754L21.2677 24.2509L17.524 24.9961L21.4922 24.4754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4922 25.5168L21.2677 25.7412L17.524 24.9961L21.4922 25.5168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6631 28.1338L20.6631 27.745L17.5283 24.9989L20.2744 28.1338L20.6631 28.1338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6963 27.4365L20.6963 27.1191L17.5222 24.9988L20.6963 27.4365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9599 28.1729L19.6425 28.1729L17.5222 24.9988L19.9599 28.1729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5249 29.4336L17.7997 29.1587L17.5249 25.0003L17.25 29.1587L17.5249 29.4336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0441 28.9688L18.2686 28.7443L17.5234 25.0006L18.0441 28.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0027 28.9688L16.7783 28.7443L17.5234 25.0006L17.0027 28.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3975 28.1358L14.7862 28.1358L17.5323 25.0009L14.3975 27.747L14.3975 28.1358Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0948 28.1768L15.4122 28.1768L17.5325 25.0027L15.0948 28.1768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3584 27.4404L14.3584 27.123L17.5325 25.0027L14.3584 27.4404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0871 25L26.2979 25.2744L26.2809 26.1097L25.7762 25.4438L24.9766 25.6858L25.4537 25H27.0871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0871 25L26.2979 24.7256L26.2809 23.8903L25.7762 24.5562L24.9766 24.3142L25.4537 25H27.0871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 33.6832L12.2032 32.8626L11.4883 32.4302L12.3174 32.3261L12.5077 31.5126L12.863 32.2687L12.0463 33.6832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 33.6832L12.6785 33.137L13.4105 33.5399L13.0861 32.7699L13.6955 32.1984L12.863 32.2687L12.0463 33.6832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 16.3207L12.6785 16.8669L13.4105 16.464L13.0861 17.234L13.6955 17.8056L12.863 17.7352L12.0463 16.3207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 16.3207L12.2032 17.1413L11.4883 17.5737L12.3174 17.6778L12.5077 18.4913L12.863 17.7352L12.0463 16.3207Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11737_3784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilipins);
export default __webpack_public_path__ + "static/media/philipins.4b732b436fe0922d1b0379e88d6f1a18.svg";
export { ForwardRef as ReactComponent };